/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

require('./src/styles/fonts.css');
require('videojs-playlist');
require('videojs-playlist-ui');
require('video.js/dist/video-js.css');
require('videojs-playlist-ui/dist/videojs-playlist-ui.css');
require('prismjs/themes/prism.css');
